import React, { useState } from 'react';
import { Mail, MapPin, Phone, Send } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    role: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
    }, 1500);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  return <div className="min-h-screen bg-slate-950" data-id="element-117">
      <section className="py-20 border-b border-slate-800" data-id="element-118">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-119">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-120">
            Contact Sales
          </h1>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-121">
            Ready to scale your network analytics? Let's talk about your
            enterprise needs.
          </p>
        </div>
      </section>

      <section className="py-24" data-id="element-122">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-123">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-124">
            {/* Contact Info */}
            <div data-id="element-125">
              <h2 className="text-2xl font-bold text-white mb-8" data-id="element-126">
                Get in touch
              </h2>
              <div className="space-y-8 mb-12" data-id="element-127">
                <div className="flex items-start" data-id="element-128">
                  <Mail className="h-6 w-6 text-cyan-400 mt-1 mr-4" data-id="element-129" />
                  <div data-id="element-130">
                    <h3 className="text-white font-medium mb-1" data-id="element-131">Email</h3>
                    <p className="text-slate-400" data-id="element-132">sales@njgod.com</p>
                  </div>
                </div>
              </div>

              <Card className="bg-slate-900/50 border-slate-800 p-8" data-id="element-133">
                <h3 className="text-xl font-bold text-white mb-4" data-id="element-134">
                  Global Presence
                </h3>
                <div className="grid grid-cols-1 gap-4 text-slate-400" data-id="element-135">
                  <div data-id="element-136">• Singapore</div>
                  <div data-id="element-137">• Tokyo</div>
                  <div data-id="element-138">• Tel Aviv</div>
                </div>
              </Card>
            </div>

            {/* Form */}
            <div data-id="element-139">
              <Card className="bg-slate-900 border-slate-800 p-8" data-id="element-140">
                {isSubmitted ? <div className="text-center py-12" data-id="element-141">
                    <div className="h-16 w-16 bg-green-500/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-142">
                      <Send className="h-8 w-8 text-green-500" data-id="element-143" />
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-4" data-id="element-144">
                      Message Sent!
                    </h3>
                    <p className="text-slate-400 mb-8" data-id="element-145">
                      Thank you for contacting us. Your message has been sent to
                      sales@njgod.com and our team will be in touch shortly.
                    </p>
                    <Button onClick={() => setIsSubmitted(false)} variant="outline" data-id="element-146">
                      Send another message
                    </Button>
                  </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-147">
                    <div className="mb-4" data-id="element-148">
                      <p className="text-sm text-slate-400" data-id="element-149">
                        Your message will be sent to{' '}
                        <span className="text-cyan-400 font-medium" data-id="element-150">
                          sales@njgod.com
                        </span>
                      </p>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-151">
                      <div data-id="element-152">
                        <label htmlFor="name" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-153">
                          Full Name
                        </label>
                        <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full bg-slate-950 border border-slate-700 rounded-lg px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent" placeholder="John Doe" data-id="element-154" />
                      </div>
                      <div data-id="element-155">
                        <label htmlFor="email" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-156">
                          Work Email
                        </label>
                        <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full bg-slate-950 border border-slate-700 rounded-lg px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent" placeholder="john@company.com" data-id="element-157" />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-158">
                      <div data-id="element-159">
                        <label htmlFor="company" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-160">
                          Company
                        </label>
                        <input type="text" id="company" name="company" required value={formData.company} onChange={handleChange} className="w-full bg-slate-950 border border-slate-700 rounded-lg px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent" placeholder="Acme Inc." data-id="element-161" />
                      </div>
                      <div data-id="element-162">
                        <label htmlFor="role" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-163">
                          Job Role
                        </label>
                        <select id="role" name="role" required value={formData.role} onChange={handleChange} className="w-full bg-slate-950 border border-slate-700 rounded-lg px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent" data-id="element-164">
                          <option value="" data-id="element-165">Select a role</option>
                          <option value="cto" data-id="element-166">CTO / VP Engineering</option>
                          <option value="network_engineer" data-id="element-167">
                            Network Engineer
                          </option>
                          <option value="security_engineer" data-id="element-168">
                            Security Engineer
                          </option>
                          <option value="devops" data-id="element-169">DevOps / SRE</option>
                          <option value="other" data-id="element-170">Other</option>
                        </select>
                      </div>
                    </div>

                    <div data-id="element-171">
                      <label htmlFor="message" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-172">
                        How can we help?
                      </label>
                      <textarea id="message" name="message" required rows={4} value={formData.message} onChange={handleChange} className="w-full bg-slate-950 border border-slate-700 rounded-lg px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent" placeholder="Tell us about your network scale and requirements..." data-id="element-173"></textarea>
                    </div>

                    <Button type="submit" className="w-full" size="lg" isLoading={isSubmitting} data-id="element-174">
                      Send Message
                    </Button>
                  </form>}
              </Card>
            </div>
          </div>
        </div>
      </section>
    </div>;
}